import { render, staticRenderFns } from "./checkgroup.vue?vue&type=template&id=6bc78748&scoped=true&"
import script from "./checkgroup.vue?vue&type=script&lang=js&"
export * from "./checkgroup.vue?vue&type=script&lang=js&"
import style0 from "./checkgroup.vue?vue&type=style&index=0&id=6bc78748&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc78748",
  null
  
)

export default component.exports